import { type FC } from 'react';
import { observer } from 'mobx-react';
import { BoxLayout } from '@/components/boxes/BoxLayout.tsx';

import { customIndicationKinds, useCustomIndications } from '@/components/boxes/hooks/useCustomIndications.ts';
import { useWorkflowIndication } from '@/components/boxes/hooks/useWorkflowIndications.ts';

import { IndicationsBox } from '@/components/boxes/indicationsBoxes/customIndications/IndicationsBox.tsx';
import { WorkflowIndicationsBox } from '@/components/boxes/indicationsBoxes/workflowIndications/workflowIndicationsBox.tsx';

export const IndicationsContainer: FC = observer(() => {
  const { customIndications } = useCustomIndications(customIndicationKinds);

  const { indicationsWithLabels } = useWorkflowIndication();

  return (
    <>
      <BoxLayout key={'indications-box'}>
        <IndicationsBox indications={customIndications} />
      </BoxLayout>
      <BoxLayout key={'workflow-box'}>
        <WorkflowIndicationsBox indicationsWithLabels={indicationsWithLabels} />
      </BoxLayout>
    </>
  );
});
